
import Vue from 'vue'
import JcdcFormGroup from '@/components/jcdc/JcdcFormGroup.vue'
import JcdcSelect from '@/components/jcdc/JcdcSelect.vue'

interface levelOneData {
  label: string
  items: Array<string>
  itemValueKey: string
  itemTextKey: string
  required: boolean
}
interface levelTwoData extends levelOneData {
  groupItemKey: string
}
export default Vue.extend({
  name: 'JcdcDualSelect',
  components: { JcdcFormGroup, JcdcSelect },
  props: {
    label: { type: String, required: true },
    dense: { type: Boolean, default: false },
    levelOneData: {
      type: Object as () => levelOneData,
      required: true,
    },
    levelTwoData: {
      type: Object as () => levelTwoData,
      required: true,
    },
  },
  data() {
    return {
      selectedLevelOne: null,
      selectedLevelTwo: null,
    }
  },
  computed: {
    filteredLevelTwo(): Array<string> {
      const { items } = this.levelTwoData
      if (this.selectedLevelOne) {
        const groupKey = this.levelTwoData.groupItemKey
        return this.levelTwoData.items.filter((item) => {
          return item[`${groupKey}`] === this.selectedLevelOne
        })
      }
      return items
    },
  },
  methods: {
    change(event, level) {
      if (level == 1) {
        this.selectedLevelOne = event
        this.selectedLevelTwo = null
        this.$emit('change-level-one', event)
      } else {
        this.selectedLevelTwo = event
        this.$emit('change-level-two', event)
      }
    },
  },
})
